// Local session storage — persists conversation sessions in localStorage.
// FREE — no backend cost. Replace with libSQL backend later if needed.

const KEY = "speakeasy_sessions";
const MAX_SESSIONS = 100;

function readAll() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

function writeAll(sessions) {
  try {
    // Keep only the latest MAX_SESSIONS
    const trimmed = sessions.slice(-MAX_SESSIONS);
    localStorage.setItem(KEY, JSON.stringify(trimmed));
  } catch (e) {
    // Quota exceeded — drop oldest
    if (e.name === "QuotaExceededError") {
      try {
        localStorage.setItem(KEY, JSON.stringify(sessions.slice(-50)));
      } catch {}
    }
  }
}

export function getAllSessions() {
  return readAll().sort((a, b) => b.startedAt - a.startedAt);
}

export function getSessionById(id) {
  return readAll().find((s) => s.id === id);
}

export function createSession({ mode, title, scenarioId, topicId, openingLine }) {
  const session = {
    id: `s_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
    mode, // "scenario" | "topic" | "free"
    title: title || "Free conversation",
    scenarioId: scenarioId || null,
    topicId: topicId || null,
    startedAt: Date.now(),
    endedAt: null,
    messages: openingLine ? [{ role: "ai", text: openingLine, time: Date.now() }] : [],
    correctionCount: 0,
  };
  const all = readAll();
  all.push(session);
  writeAll(all);
  return session;
}

export function appendMessage(sessionId, message) {
  const all = readAll();
  const idx = all.findIndex((s) => s.id === sessionId);
  if (idx < 0) return null;
  all[idx].messages.push(message);
  if (message.correction) all[idx].correctionCount = (all[idx].correctionCount || 0) + 1;
  writeAll(all);
  return all[idx];
}

export function endSession(sessionId) {
  const all = readAll();
  const idx = all.findIndex((s) => s.id === sessionId);
  if (idx < 0) return null;
  all[idx].endedAt = Date.now();
  writeAll(all);
  return all[idx];
}

export function deleteSession(sessionId) {
  const all = readAll().filter((s) => s.id !== sessionId);
  writeAll(all);
}

export function clearAllSessions() {
  localStorage.removeItem(KEY);
}

export function getSessionStats() {
  const all = readAll();
  const totalMessages = all.reduce((sum, s) => sum + (s.messages?.length || 0), 0);
  const userMessages = all.reduce(
    (sum, s) => sum + (s.messages?.filter((m) => m.role === "user").length || 0),
    0
  );
  const totalCorrections = all.reduce((sum, s) => sum + (s.correctionCount || 0), 0);
  return {
    sessionCount: all.length,
    totalMessages,
    userMessages,
    totalCorrections,
  };
}
